import React from 'react';
import { motion } from 'framer-motion';
import { decisionTrail, operationalSystems, recordStores } from '../../data/research';
import { fadeUp } from '../../utils/motion';
export function OperationalSystems() {
  return <>
      <section className="bg-white py-20 lg:py-28" data-id="element-1839" data-mp="3478qaks4n5c9">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16" data-id="element-1840" data-mp="2z7memfry5x5k">
          <motion.h2 {...fadeUp} className="lg:col-span-4 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-1841" data-mp="q0difc9avoe">
            The operational systems behind those capabilities
          </motion.h2>
          <motion.div {...fadeUp} className="lg:col-span-8 overflow-x-auto" data-id="element-1842" data-mp="3myrw0zdjcxhz">
            <table className="w-full text-left border-collapse" data-id="element-1843" data-mp="3hxm2x0fyr87x">
              <thead data-id="element-1844" data-mp="2biuso64yab18">
                <tr className="border-b-2 border-ink-dark" data-id="element-1845" data-mp="2bjcxvs9lbzla">
                  <th scope="col" className="py-3 pr-6 font-heading font-bold text-sm text-ink-dark w-2/5" data-id="element-1846" data-mp="26i721lkmvw7j">
                    System
                  </th>
                  <th scope="col" className="py-3 font-heading font-bold text-sm text-ink-dark" data-id="element-1847" data-mp="1mc67gagr15m">
                    Primary responsibility
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-1848" data-mp="3nxzhla8qh1gs">
                {operationalSystems.map(row => <tr key={row.system} className="border-b border-line align-top" data-id="element-1849" data-mp="3ssvb6etmbww0">
                    <th scope="row" className="py-4 pr-6 font-semibold text-ink-dark" data-id="element-1850" data-mp="3f2jioet4fw4c">
                      {row.system}
                    </th>
                    <td className="py-4 text-ink-muted leading-relaxed" data-id="element-1851" data-mp="3555epeodwzsx">{row.responsibility}</td>
                  </tr>)}
              </tbody>
            </table>
          </motion.div>
        </div>
      </section>

      <section className="bg-surface-bg py-20 lg:py-28" data-id="element-1852" data-mp="2w476ek6wy64j">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1853" data-mp="2w6tdkipw6jm8">
          <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-12" data-id="element-1854" data-mp="304r6nwms9puw">
            <h2 className="lg:col-span-5 font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight" data-id="element-1855" data-mp="16owiql47vldu">
              Separate knowledge from personal records
            </h2>
            <p className="lg:col-span-7 text-lg text-ink-muted leading-relaxed lg:pt-3" data-id="element-1856" data-mp="wy1sz6rri3nn">
              The systems could refer to one another through controlled
              identifiers and APIs. Private records would not need to be placed
              in a broadly searchable knowledge graph.
            </p>
          </motion.div>

          <motion.div {...fadeUp} className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1857" data-mp="1fo02zsf4e6tx">
            {recordStores.map((store, index) => <div key={store.name} className={`rounded-lg p-6 lg:p-8 border ${index === 0 ? 'bg-white border-line' : 'bg-surface-muted border-line'}`} data-id="element-1858" data-mp="1bld63d3ldvpv" data-mpi={index}>
                <p className="text-xs font-medium text-teal mb-2" data-id="element-1859" data-mp="66n64j8sf7j">
                  {index === 0 ? 'Shared knowledge' : 'Private records'}
                </p>
                <h3 className="font-heading font-bold text-xl text-ink-dark mb-3" data-id="element-1860" data-mp="2fw6jcsme0fwf">{store.name}</h3>
                <p className="text-ink-muted leading-relaxed" data-id="element-1861" data-mp="2kv9pyhi0mu6i">{store.holds}</p>
              </div>)}
          </motion.div>

          <motion.div {...fadeUp} className="mt-16" data-id="element-1862" data-mp="2pn1hau8zx3xp">
            <h3 className="font-heading font-bold text-2xl text-ink-dark mb-6" data-id="element-1863" data-mp="2pnuhfcdg8v6v">
              A reviewable decision trail
            </h3>
            <ol className="flex flex-wrap items-center gap-y-3" data-id="element-1864" data-mp="2zje89kd5p3or">
              {decisionTrail.map((step, index) => <li key={step} className="flex items-center" data-id="element-1865" data-mp="33n2h06diy5bl" data-mpi={index}>
                  <span className={`rounded-md px-4 py-2.5 text-sm font-medium whitespace-nowrap ${index === 4 ? 'bg-navy text-white' : 'bg-white border border-line text-ink-dark'}`} data-id="element-1866" data-mp="38ldrmjbn8juv">
                    {step}
                  </span>
                  {index < decisionTrail.length - 1 && <span aria-hidden="true" className="px-2 text-teal" data-id="element-1867" data-mp="ivczc0stgse1">
                      →
                    </span>}
                </li>)}
            </ol>
          </motion.div>
        </div>
      </section>
    </>;
}